import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-logisticsDelivery",
  "use": "icon-logisticsDelivery-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-logisticsDelivery\"><defs><style type=\"text/css\"></style></defs><path d=\"M950.4 456.96c-0.64-1.28-0.64-2.56-1.28-3.2l-188.16-188.16C753.28 257.92 743.68 255.36 734.08 256L576 256c0-70.4-57.6-128-128-128L128 128C57.6 128 0 185.6 0 256l0 480C0 753.92 14.08 768 32 768L64 768c0 70.4 57.6 128 128 128 70.4 0 128-57.6 128-128l320 0c0 70.4 57.6 128 128 128 70.4 0 128-57.6 128-128l32 0c17.92 0 32-14.08 32-32l0-256C960 471.04 956.16 462.72 950.4 456.96zM192 832c-35.2 0-64-28.8-64-64 0-35.2 28.8-64 64-64s64 28.8 64 64C256 803.2 227.2 832 192 832zM768 832c-35.2 0-64-28.8-64-64 0-35.2 28.8-64 64-64 35.2 0 64 28.8 64 64C832 803.2 803.2 832 768 832zM576 512 576 320l128 0 192 192L576 512z\" p-id=\"2668\" fill=\"#ebeef5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/logisticsDelivery.svg
// module id = +LR/
// module chunks = 183